import {
  validatePresence,
  validateNumber,
} from 'ember-changeset-validations/validators';

export const AdditionalBookingChargeValidation = {
  amount: [validateNumber({ gt: 0 })],
  name: [validatePresence(true)],
};
